import React ,{useEffect} from 'react'
import hero from '../Assets/hero.png'
import AOS from 'aos';
import 'aos/dist/aos.css'

const Herosec = () => {
  useEffect(()=>{
    AOS.init({duration:1000})
},[])

  return (
    <div className='bg-gradient-to-r from-[#00B7E6] via-[#00CBDF] to-[#00DCD8] sm:pt-11 pt-3'>
        <div  >
        </div>
        <div>
          <div className='grid sm:grid-cols-2 grid-cols-1 place-items-center' data-aos="fade-up">
            <div className='grid-cols-1'>

               <div className=' flex flex-col pt-1'> <p className='text-white text-3xl font-semibold sm:px-10 px-7  sm:ml-9 ml-3 sm:mt-11 mt-1 sm:pt-7 pt-1 font-breado'>Let us build your professional space and help you stand Out with our portfolio expertise</p><p className='text-white text-md font-medium sm:px-10 px-7 sm:ml-9 ml-3 sm:mt-2 mt-2 '>At Riddle, we are dedicated to helping students and individuals upskill themselves by crafting outstanding resumes and portfolio Optimizations. </p></div>
</div>
               <div><img className='h-96 w-max sm:pt-0 pt-4' src={hero} alt="hero"/></div>

          </div>
        </div>
    </div>
  )
}

export default Herosec